<template>
  <input type="text" :disabled="disabled" tabindex="0" class="form-control" :value="formattedValue" @input="onInput"  />
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop} from "vue-property-decorator";

@Component({
  name: "PayoutMaskedInput2"
})
export default class PayoutMaskedInput2 extends Vue{
  @Prop({default: ''})
  value: string

  @Prop({default: false})
  disabled

  @Prop({default: '57 #### #### ##'})
  mask: string

  get formattedValue(){
    return this.formatByMask('' + this.value, this.mask);
  }
  set formattedValue(newValue: any) {
    this.$emit('input', this.formatByMask('' + newValue, this.mask));
  }

  onInput(event: any) {
    this.formattedValue = event.target.value;
    this.$forceUpdate();
  }

  formatByMask(phoneNumberInputValue: string = '', mask = '57 #### #### ##'): string {
    // Remove all non-digit characters from input
    const numbers = phoneNumberInputValue.replace(/\D/g, '');

    // Initialize variables
    let result = '';
    let numberIndex = 0;

    // Iterate through mask characters
    for (let i = 0; i < mask.length; i++) {
      // If we've used all numbers, break
      if (numberIndex >= numbers.length) {
        break;
      }

      // If mask character is #, replace with number
      if ((mask[i] === '#') || (mask[i] === numbers[numberIndex])) {
        result += numbers[numberIndex];
        numberIndex++;
      } else {
        // If mask character is not #, keep the mask character
        result += mask[i];
      }
    }

    return result;
  }
}
</script>

<style scoped>

</style>
